import * as Sentry from "@sentry/react";
import type { ErrorInfo } from "react";

declare const __APP_VERSION__: string;

let initialized = false;

function parseSampleRate(raw: string | undefined, fallback: number): number {
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed < 0 || parsed > 1) {
    return fallback;
  }
  return parsed;
}

export function initSentry(): void {
  if (initialized) {
    return;
  }

  const dsn = import.meta.env.VITE_SENTRY_DSN_WEB;
  if (!dsn) {
    if (import.meta.env.PROD) {
      console.warn("[sentry:web] VITE_SENTRY_DSN_WEB no está configurado; Sentry queda deshabilitado en producción.");
    }
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    release: import.meta.env.VITE_SENTRY_RELEASE ?? __APP_VERSION__,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: parseSampleRate(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE, 0),
  });

  initialized = true;
}

export function captureBoundaryError(error: Error, errorInfo: ErrorInfo): void {
  const stack = errorInfo.componentStack?.trim();
  Sentry.captureException(error, {
    extra: stack ? { componentStack: stack } : undefined,
  });
}

/**
 * Reported by the translation DOM guard when it swallows a mutation React could
 * not have survived. Warning level: the app kept working, but we want to know
 * how often a translated page is being used.
 */
export function captureTranslationDomMismatch(operation: string, translated: boolean): void {
  Sentry.captureMessage("DOM mutation sobre un nodo reparentado (traductor)", {
    level: "warning",
    extra: { operation, translated },
  });
}
